import PropTypes from 'prop-types';
import React from 'react';
import css from './SearchNoResults.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var NoResults = function NoResults(_ref) {
  var popularSearches = _ref.popularSearches;
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsxs("div", {
      "aria-live": "polite",
      role: "status",
      children: [/*#__PURE__*/_jsx("h1", {
        children: "Out of bounds"
      }), /*#__PURE__*/_jsx("p", {
        children: "We\u2019re sorry, but we can\u2019t find anything for that search."
      })]
    }), /*#__PURE__*/_jsxs("ul", {
      className: css.list,
      children: [/*#__PURE__*/_jsx("li", {
        className: css.listItem,
        children: /*#__PURE__*/_jsx("h2", {
          className: css.title,
          children: "Popular Searches"
        })
      }), popularSearches.map(function (search) {
        return /*#__PURE__*/_jsx("li", {
          className: css.listItem,
          children: /*#__PURE__*/_jsx("a", {
            className: css.link,
            href: search.url,
            children: search.title
          })
        }, search.id);
      })]
    })]
  });
};

NoResults.propTypes = {
  popularSearches: PropTypes.arrayOf(PropTypes.shape()).isRequired
};
export default NoResults;